import { render, staticRenderFns } from "./PersonInfoRow.vue?vue&type=template&id=0ed133ea&scoped=true&"
import script from "./PersonInfoRow.vue?vue&type=script&lang=js&"
export * from "./PersonInfoRow.vue?vue&type=script&lang=js&"
import style0 from "./PersonInfoRow.vue?vue&type=style&index=0&id=0ed133ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed133ea",
  null
  
)

export default component.exports